import React, { Fragment, useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useParams } from "react-router-dom";
import SharedDataContext from "../../../_helper/SharedData";
import CarDetails from "./CarDetails";
import CarTrips from "./CarTrips";
import SearchTable from "../../Common/Component/SearchTable";
import FilterTable from "../../Common/Component/FilterTable";
import { getCarDetail } from "../../../Services/Car.service";
import { showAlert } from "../../../Services/Shared.service";
import CarDocuments from "./CarDocuments";
import CarEVBatteryTransactions from "./CarEVBatteryTransactions";
const CarInfo = () => {
    const { setShowApiLoader, globalCityField, cityData } =
        useContext(SharedDataContext);
    const [carList, setCarList] = useState("Trips");
    const { carId } = useParams();
    const [carObj, setCarObj] = useState({});

    useEffect(() => {
        fetchCarDetails()
    }, []);

    const fetchCarDetails = () => {
        setShowApiLoader(true);
        getCarDetail(carId)
            .then((result) => {
                setShowApiLoader(false);
                if (result.data) {
                    setCarObj(result.data);
                }
            })
            .catch((err) => {
                setShowApiLoader(false);
                setCarObj({});
                showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
            });
    }
    return (
        <Fragment>
            <Container fluid={true}>
                <Col xs="12" className="padding-30">
                    <CarDetails
                        carObj={carObj}
                    />
                </Col>
                <Col md="12" className="driver-list-details">
                    <div>
                        {carList == 'Trips' ? <FilterTable /> : ''}
                    </div>
                    <div>
                        <Row className="trip-options">
                            <div>
                                <ul className="booking-tabs">
                                    <li
                                        className={`${carList == "Trips" ? "active" : ""}`}
                                        onClick={() => setCarList("Trips")}
                                    >
                                        Trips
                                        <div className="arrow-down"></div>
                                    </li>
                                    <li
                                        className={`${carList == "Documents" ? "active" : ""}`}
                                        onClick={() => setCarList("Documents")}
                                    >
                                        Documents
                                        <div className="arrow-down"></div>
                                    </li>
                                    {carObj.isEv ? <li
                                        className={`${carList == "EV Battery Transactions" ? "active" : ""}`}
                                        onClick={() => setCarList("EV Battery Transactions")}
                                    >
                                        EV Battery Transactions
                                        <div className="arrow-down"></div>
                                    </li> : null}
                                </ul>
                            </div>
                        </Row>
                    </div>
                    <div className="search-table">
                        {carList == 'Trips' ? <SearchTable /> : ""}
                    </div>
                </Col>
                <Col className="driver-list-data">
                    {carList == "Trips" ? <CarTrips carId={carId} serviceCityId={globalCityField?.value?.id ? globalCityField.value.id : null} /> : ""}
                    {carList == "Documents" ? <CarDocuments carNo={carObj.carNo} /> : ""}
                    {carList == "EV Battery Transactions" ? <CarEVBatteryTransactions carId={carId} /> : ""}
                </Col>
            </Container>
        </Fragment>
    );
};

export default CarInfo;
